import BybVrCard from "@Components/common/byb-ds/cards/byb-vr-card";
import useI18n from "@i18n";
import { Typography, useTheme } from "@mui/material";

const ActivityEmptyState = () => {
  const theme = useTheme();
  const { i18n } = useI18n();

  return (
    <BybVrCard sx={{ minHeight: theme.spacing(22), alignItems: "center", textAlign: "center", gap: theme.spacing(1.5) }}>
      <Typography variant="text2xl700" color="common.white">
        {i18n("activity.empty.title")}
      </Typography>
      <Typography variant="textLg400" color="text.secondary">
        {i18n("activity.empty.subtitle")}
      </Typography>
    </BybVrCard>
  );
};

export default ActivityEmptyState;
